var map = {
	"./bill/index.vue": 5996,
	"./carousel/index.vue": 268,
	"./category/index.vue": 2199,
	"./couponcode/index.vue": 115,
	"./couponpackage/index.vue": 1803,
	"./educationstage/index.vue": 123,
	"./feedback/index.vue": 5729,
	"./file/index.vue": 9647,
	"./grade/index.vue": 3550,
	"./test/index.vue": 1668
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5899;